// extracted by mini-css-extract-plugin
export default {"root":"MetricWidget_root__W1xEY","header":"MetricWidget_header__q13zH","gaugeContainer":"MetricWidget_gaugeContainer__sulKN"};